import { gtm } from '../modules/gtm.js';

export const sourceMethods = {

	_buildGeoJSON( list ) {
		return {
			type: 'FeatureCollection',
			features: list
				.filter( i => i.lat && i.lng )
				.map( i => ( {
					type: 'Feature',
					geometry: { type: 'Point', coordinates: [ i.lng, i.lat ] },
					properties: {
						id:         i.id,
						title:      i.title,
						gpx_url:    i.gpx_url,
						permalink:  i.permalink,
						thumbnail:  i.thumbnail,
						distance:   i.distance,
						duration:   i.duration,
						climb:      i.climb,
						difficulty: i.difficulty,
						bike_types: JSON.stringify( i.bike_types ),
					},
				} ) ),
		};
	},

	_addSource() {
		this.map.addSource( 'itineraries', {
			type:           'geojson',
			data:           this._buildGeoJSON( this.itineraries ),
			cluster:        true,
			clusterMaxZoom: 11,
			clusterRadius:  50,
		} );
	},

	_addLayers() {
		this.map.addLayer( {
			id:     'clusters',
			type:   'circle',
			source: 'itineraries',
			filter: [ 'has', 'point_count' ],
			paint: {
				'circle-color': [
					'step', [ 'get', 'point_count' ],
					'#062423', 5,
					'#1a4a48', 10,
					'#2e706d',
				],
				'circle-radius': [
					'step', [ 'get', 'point_count' ],
					18, 5, 24, 10, 30,
				],
				'circle-opacity': 0.9,
			},
		} );

		this.map.addLayer( {
			id:     'cluster-count',
			type:   'symbol',
			source: 'itineraries',
			filter: [ 'has', 'point_count' ],
			layout: {
				'text-field': '{point_count_abbreviated}',
				'text-size':  13,
				'text-font':  [ 'DIN Offc Pro Medium', 'Arial Unicode MS Bold' ],
			},
			paint: { 'text-color': '#fff' },
		} );

		this.map.addLayer( {
			id:     'unclustered-point',
			type:   'symbol',
			source: 'itineraries',
			filter: [ '!', [ 'has', 'point_count' ] ],
			layout: {
				'icon-image':         'itinerary-pin',
				'icon-size':          1,
				'icon-anchor':        'bottom',
				'icon-allow-overlap': true,
			},
		} );
	},

	_bindMapEvents() {
		// Single click expands all leaves of the cluster into view (no multi-click needed)
		this.map.on( 'click', 'clusters', ( e ) => {
			const [ feature ] = this.map.queryRenderedFeatures( e.point, { layers: [ 'clusters' ] } );
			const clusterId   = feature.properties.cluster_id;
			const source      = this.map.getSource( 'itineraries' );

			source.getClusterLeaves( clusterId, Infinity, 0, ( err, leaves ) => {
				if ( err || ! leaves.length ) return;

				if ( leaves.length === 1 ) {
					this.map.easeTo( { center: leaves[ 0 ].geometry.coordinates, zoom: 12 } );
					return;
				}

				const lngs = leaves.map( l => l.geometry.coordinates[ 0 ] );
				const lats = leaves.map( l => l.geometry.coordinates[ 1 ] );
				const pad  = this._getSidebarPadding();

				this.map.fitBounds(
					[ [ Math.min( ...lngs ), Math.min( ...lats ) ], [ Math.max( ...lngs ), Math.max( ...lats ) ] ],
					{
						padding:  { top: pad.top + 60, bottom: pad.bottom + 60, left: pad.left + 60, right: pad.right + 60 },
						maxZoom:  12,
						duration: 600,
					}
				);
			} );
		} );

		this.map.on( 'click', 'unclustered-point', ( e ) => {
			const feature = e.features[ 0 ];
			const itiId   = parseInt( feature.properties.id, 10 );
			this._highlightItinerary( itiId );
			this._openItinerary( feature );
			const iti = this.itineraries.find( i => i.id === itiId );
			gtm.clickItineraryMap( {
				itinerary_id     : itiId,
				itinerary_name   : feature.properties.title || '',
				itinerary_region : iti?.region || '',
			} );
		} );

		[ 'clusters', 'unclustered-point' ].forEach( layer => {
			this.map.on( 'mouseenter', layer, () => { this.map.getCanvas().style.cursor = 'pointer'; } );
			this.map.on( 'mouseleave', layer, () => { this.map.getCanvas().style.cursor = ''; } );
		} );
	},
};
